export default {
    name: 'vehicles',
    component: () => import(/* webpackChunkName: "vehicles-Layout" */ '@/modules/vehicles/layouts/Layout'),
    children: [
        {
            path: '',
            name: 'dashboard.vehicles.index',
            component: () => import(/* webpackChunkName: "vehicles-index" */ '@/modules/vehicles/views/Index'),
        },
        {
            path: 'create',
            name: 'dashboard.vehicles.create',
            component: () => import(/* webpackChunkName: "vehicles-create" */ '@/modules/vehicles/views/Create'),
        },
        {
            path: ':id/edit',
            name: 'dashboard.vehicles.edit',
            component: () => import(/* webpackChunkName: "vehicles-edit" */ '@/modules/vehicles/views/Edit'),
        },
    ]
}